import { inject, injectable } from "inversify";
import { OperationDetailsModelFS } from "@/extensions/models/history/operationDetailsModelFS";
import { OperationsHistoryApi } from "fs-pb-vue2/services/api/OperationsHistoryApi";
import IAlertService from "fs-pb-vue2/services/alert/IAlertService";
import IErrorService from "fs-pb-vue2/services/error/IErrorService";
import { DiTokens } from "fs-pb-vue2/services/diTokens";
import ContractStatementService from "fs-pb-vue2/services/history/ContractStatementService";

@injectable()
/** Сервис выписки по счету */
export default class ContractStatementServiceFS
  extends ContractStatementService {
  constructor(
    @inject(DiTokens.AlertService) private alertService: IAlertService,
    @inject(DiTokens.ErrorService) private errorService: IErrorService
  ) { super(alertService, errorService) }

  public async getOperationDetails(
    operation: any
  ): Promise<OperationDetailsModelFS> {
    try {
      const requestData = await OperationsHistoryApi.getOperationAsync(
        operation.Id,
        operation.ReferenceId
      );
      const respondentCode = parseInt(requestData.respondentCode);
      if (!operation.IsRespondentActive) 
        operation.IsRespondentActive = requestData.isRespondentActive;
      if (requestData.operationId)
        operation.Id = requestData.operationId;
      const operationDetail = new OperationDetailsModelFS(operation, requestData, null, operation.modalDetails);
      if (!isNaN(respondentCode)) {
        operationDetail.RespondentData = await OperationsHistoryApi.getRespondentAsync(
          respondentCode
        );
      }
      // operationDetail.RequestData?.details.forEach(
      //   (d: DeclarationPropertyValueData) => {
      //     d.Value = replaceCurrencySymb(d.Value);
      //   }
      // );

      // if (operationDetail.RequestData?.details)
      //   operationDetail.Details = operationDetail.RequestData?.details;
       
      return operationDetail;
    } catch (e) {
      await this.errorService.errorHandler(e, false, true, "");
      throw e;
    }
  }
}
